import {
  QueryClient,
  defaultShouldDehydrateQuery,
} from "@tanstack/react-query";
import { toast } from "sonner";

import { APIClientError } from "@workspace/api/utils";
import { logger } from "@workspace/shared/logger";

import { handleRestrictedFeatureError } from "~/modules/organization/lib/restricted-feature";

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: 60 * 1000,
      },
      dehydrate: {
        shouldDehydrateQuery: (query) =>
          defaultShouldDehydrateQuery(query) ||
          query.state.status === "pending",
      },
      mutations: {
        onError: (error: unknown) => {
          const normalized =
            typeof error === "object" && error && "error" in error
              ? (error as { error: unknown }).error
              : error;

          if (
            handleRestrictedFeatureError(normalized) ||
            handleRestrictedFeatureError(error)
          ) {
            logger.error(normalized);
            return;
          }

          const message =
            normalized instanceof APIClientError
              ? normalized.message
              : normalized instanceof Error
              ? normalized.message
              : typeof normalized === "string"
                ? normalized
                : typeof normalized === "object"
                  ? "Request failed. Check server logs for details."
                  : "Request failed.";

          logger.error(normalized);
          toast.error(message || "Request failed.");
        },
      },
    },
  });
